import { setTimeDurationFormat as setTimeDurationFormatDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

export type Props = ApiMethodBase & {
    durationFormat?: String,
}

export const setTimeDurationFormat = ({
    durationFormat,
    eventEmitter
}: Props) => {
    setTimeDurationFormatDiagram(durationFormat);
};

